export default class PeriodoAtualHelper {

    constructor() {
        throw 'Não é possível instanciar PeriodoAtualHelper';
    }

    static validaPeriodo(dataInicial, dataFinal) {
        let hoje = new Date();
        let inicio = new Date(dataInicial);
        let fim = new Date(dataFinal);
        return inicio <= hoje && fim >= hoje;
    }

    static periodoEncerrado(dataFinal) {
      let hoje = new Date();
      let fim = new Date(dataFinal);
      return hoje > fim;
    }

}



// WEBPACK FOOTER //
// ./src/helpers/PeriodoAtualHelper.js